// extracted by mini-css-extract-plugin
export default {"content":"publish__content__vj7hG","error":"publish__error__xJ_u1","actions":"publish__actions__WQktY"};